/**
 * Compare ordered crew user-id lists (same semantics as block / aspect worker_assignment order).
 *
 * @param {Array<number|string>|null|undefined} a
 * @param {Array<number|string>|null|undefined} b
 * @returns {boolean}
 */
export function scheduleCrewIdListsEqual(a, b) {
  if (a == null || b == null) {
    return false;
  }
  if (a.length !== b.length) {
    return false;
  }
  return a.every((id, i) => Number(id) === Number(b[i]));
}
